<template>
  <div>
    <table class="table table-bordered">
      <tr>
        <th>PRODUCTO</th>
        <th>VENTAS</th>
        <th>POLLO</th>
      </tr>
      <tr v-for="(l, i) in detail" :key="i">
        <td>{{ l.product_name }}</td>
        <td>{{ l.quantity }}</td>
        <td>{{ l.chicken }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    detail: []
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    load(detail) {
      console.log("det", detail);
      this.detail = detail;
    }
  }
};
</script>

<style scoped></style>
